import { Button } from 'components/common'
import { ICellRendererParams } from '@ag-grid-community/core'
import { useNavigate } from 'react-router-dom'
import { PAGE_UPDATE_CHAIN } from 'utils/constants'

type ActionCellRendererProps = {
  params: ICellRendererParams
  isEditor: boolean
  getChainToDelete: (params: ICellRendererParams) => void
}

const ActionCellRenderer = ({
  params,
  isEditor,
  getChainToDelete,
}: ActionCellRendererProps) => {
  const navigate = useNavigate()

  if (!isEditor) return <></>

  return (
    <div className="flex h-full items-center justify-center gap-3">
      <Button
        size="small"
        variant="outline"
        className="w-20"
        buttonText="Edit"
        type="button"
        onClick={() => navigate(`${PAGE_UPDATE_CHAIN.path}/${params.data._id}`)}
      />
      <Button
        size="small"
        className="w-20"
        buttonText="Delete"
        type="button"
        onClick={() => getChainToDelete(params)}
      />
    </div>
  )
}

export default ActionCellRenderer
